import { FloorGuideType } from '@/enums/floor-guide';
import { useMemo } from 'react';

export const PATHS = {
    INDEX: '/',
    HOME: {
        INDEX: '/home',
    },
    FLOOR_GUIDE: {
        INDEX: '/floor-guide',
        CURRENT_LOCATION: (studioFloorID: string, studioPoiId: string) =>
            `/floor-guide?studioFloorID=${studioFloorID}&studioPoiId=${studioPoiId}&floorGuideType=${FloorGuideType.MARKER}`,
        DIRECTION_GUIDE: (studioFloorID: string, studioPoiId: string) =>
            `/floor-guide?studioFloorID=${studioFloorID}&studioPoiId=${studioPoiId}&floorGuideType=${FloorGuideType.DIRECTION}`,
        DIRECTION_GUIDE_FROM_PARKING: (title: string, floorId: string) =>
            `/floor-guide?title=${title}&floorId=${floorId}&floorGuideType=${FloorGuideType.DIRECTION_FROM_PARKING}`,
    },
    SHOP: {
        INDEX: '/shop',
    },
    PARKING: {
        INDEX: '/parking',
    },
    EVENTS: {
        INDEX: '/events',
    },
    FACILITY: {
        INDEX: '/facility',
    },
    FAQ: {
        INDEX: '/faq',
    },
    TOUR_GUIDE: {
        INDEX: '/tour-guide',
    },
    ERRORS: {
        INDEX: '/errors',
        404: '/errors/404',
        500: '/errors/500',
    },
};

export interface Route {
    name: string;
    path?: string;
    pathName?: string;
    active?: boolean;
    pages?: Route[];
}

export function useRoutes(): Route[] {
    return useMemo(() => {
        return [
            { name: '홈', path: PATHS.HOME.INDEX, pathName: '/home/HomePage.tsx', active: true },
            { name: '층별안내', path: PATHS.FLOOR_GUIDE.INDEX, pathName: '/floor-guide/FloorGuidePage.tsx', active: true },
            { name: '매장검색', path: PATHS.SHOP.INDEX, pathName: '/shop/ShopPage.tsx', active: true },
            { name: '행사안내', path: PATHS.EVENTS.INDEX, pathName: '/events/EventsPage.tsx', active: true },
            { name: '주차안내', path: PATHS.PARKING.INDEX, pathName: '/parking/ParkingPage.tsx', active: true },
            { name: '편의시설', path: PATHS.FACILITY.INDEX, pathName: '/facility/FacilityPage.tsx', active: true },
            { name: '자주 묻는 질문', path: PATHS.FAQ.INDEX, pathName: '/faq/FAQPage.tsx', active: true },
            {
                name: 'errors',
                path: PATHS.ERRORS.INDEX,
                active: false,
                pages: [
                    {
                        name: '404',
                        active: true,
                        path: PATHS.ERRORS[404],
                        pathName: 'errors/Error404.tsx',
                    },
                    {
                        name: '500',
                        active: true,
                        path: PATHS.ERRORS[500],
                        pathName: 'errors/Error500.tsx',
                    },
                ],
            },
        ];
    }, []);
}
